/* unplugin-vue-components disabled */import { render } from "./cba25437429761.vue?vue&type=template&id=32811e8b&scoped=true"
import script from "./cba25437429761.vue?vue&type=script&lang=js"
export * from "./cba25437429761.vue?vue&type=script&lang=js"

import "./cba25437429761.vue?vue&type=style&index=0&id=32811e8b&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32811e8b"]])

export default __exports__